<div class="row">
  <div class="col-md-12">

    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }"
      style="margin-bottom: 0px; min-height: 730px;">

      <div class="box-header text-center" style="border-bottom: 1px solid #ddd;">
        <h3 class="box-title">Cadastramento de Equipamento</h3>
      </div>


      <div class="box-body" style="padding:20px; min-height: 500px;">

        <form novalidate style="padding-top: 10px;" [formGroup]="form" id="form" (validSubmit)="submit()">

          <div class="form-row">

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="">Tipo de Equipamento <span class="text-danger pl-2">(*)</span></label>
                <select for="" class="form-control" formControlName="tipoEquipamentoId" required 
                (change)="changeTipoOrClasseEquipamento()">
                  <option *ngFor="let t of this.tiposEquipamentosComboBox" [value]="t.id">{{ t.descricao }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="">Classe equipamento <span class="text-danger pl-2">(*)</span></label>
                <select for="" class="form-control" formControlName="classeEquipamentoId" required
                  (change)="changeTipoOrClasseEquipamento()">
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.classesEquipamento" [value]="t.id">{{ t.descricao }}</option>
                </select>
              </div>
            </div>

           


            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Código<span class="text-danger pl-2">(*)</span></label>
                <input class="form-control" formControlName="nome" type="text" maxlength="20" required > 
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('nome').hasError('isNotUniqueNomeEquipamento')">Este nome/código já está
                    uso</small>
                </section>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Grupo local</label>

                <select for="" class="form-control" formControlName="grupoLocalNivel1Id" (change)="getLocaisByGrupoLocalNivelId($event.target.value)">
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.niveis1" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Local<span class="text-danger pl-2">(*)</span></label>
                <select for="" class="form-control" formControlName="localId" required>
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.locais" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>
          </div><!-- form-row -->

          <div class="form-row">

            <div class="col-md-12">
              <div class="position-relative form-group">
                <label for="">Descricao<span class="text-danger pl-2">(*)</span></label>
                <input class="form-control" formControlName="descricao" type="text" maxlength="100" required>
              </div>
            </div>
          </div>

          <div class="form-row">

            <div class="col-md-12">
              <div class="position-relative form-group">
                <label for="">Utilização</label>
                <input class="form-control" formControlName="util" type="text" maxlength="60">
              </div>
            </div>
          </div>


          <div class="form-row">
            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Nº de série</label>
                <input class="form-control" formControlName="numeroSerie" type="text" maxlength="15">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('descricao').hasError('isNotUniqueNumeroSerieEquipamento')">Esta N° de série já
                    está uso</small>
                </section>
              </div>
            </div>
            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Nº patrimônio</label>
                <input class="form-control" formControlName="numeroPatrimonio" type="text" maxlength="15">
              </div>
            </div>
            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Classe rotina <span class="field-required">(*) [1 a 5]</span> </label>
                <input class="form-control text-center" formControlName='classe' type="text" [textMask]="{mask: maskClasse}">
              </div>
            </div>
          </div>


          <div class="form-row">

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Modelo</label>
                <input class="form-control" formControlName="modelo" type="text" maxlength="40">
              </div>
            </div>


            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Ano fabricação</label>
                <input class="form-control" formControlName="anoFabricacao" type="text" [textMask]="{mask: maskAno}">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('anoFabricacao').hasError('isInconsistent')">Verifique o valor</small>
                </section>
              </div>
            </div>

            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Ano instalação</label>
                <input class="form-control" formControlName='anoInstalacao' type="text" [textMask]="{mask: maskAno}">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('anoInstalacao').hasError('isInconsistent')">Verifique o valor</small>
                </section>
              </div>
            </div>

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Fabricante<span class="text-danger pl-2">(*)</span></label>
                <select for="" class="form-control" formControlName="fabricanteId" required>
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.fabricantes" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>
          </div>


          <div class="form-row">

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Largura</label>
                <input currencyMask class="form-control" formControlName="largura" type="text" maxlength="13"
                  [options]="{ prefix: '', thousands: '.', decimal: ',' }">
              </div>
            </div>


            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Altura</label>
                <input currencyMask class="form-control" formControlName="altura" type="text" maxlength="13"
                  [options]="{ prefix: '', thousands: '.', decimal: ',' }">
              </div>
            </div>




            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="">Comprimento</label>
                <input currencyMask class="form-control" formControlName="comprimento" type="text" maxlength="13"
                  [options]="{ prefix: '', thousands: '.', decimal: ',' }">
              </div>
            </div>

            



          </div>

         
          <section *ngIf="this.form.get('tipoEquipamentoId').value > 1">

            <p class="title-divider fb mt-3 mb-3"><span> {{this.tipoEquipamentoDescricao}}</span></p>

            <!-- Transformador -->
            <section *ngIf="this.form.get('tipoEquipamentoId').value == 2" class="animated fadeInDown">

              <div class="form-row">

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="">Numero</label>
                    <input class="form-control" formControlName="numero" type="text" maxlength="7">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="position-relative form-group">
                    <label for="">Potência</label>
                    <input class="form-control" formControlName="potencia" type="text" maxlength="10">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <label for="">Tapos</label>
                    <input class="form-control" formControlName="taps" type="text" maxlength="7">
                  </div>
                </div>

              </div>

              <div class="form-row">

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="">VP</label>
                    <input class="form-control" formControlName="vp" type="text" maxlength="7">
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="position-relative form-group">
                    <label for="">VS</label>
                    <input class="form-control" formControlName="vs" type="text" maxlength="7">
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <label for="">Tombamento</label>
                    <input class="form-control" formControlName="tombamento" type="text" maxlength="12">
                  </div>
                </div>

              </div>

            </section>


            <!-- Cabo Distribuição -->
            <section *ngIf="this.form.get('tipoEquipamentoId').value == 3" class="animated fadeInDown">

              <div class="form-row">

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="">Cabo</label>
                    <input class="form-control" formControlName="cabo" type="text" maxlength="7">
                  </div>
                </div>

                <div class="col-md-8">
                  <div class="position-relative form-group">
                    <label for="">Tipo de Cabo</label>
                    <input class="form-control" formControlName="tipo" type="text" maxlength="13">
                  </div>
                </div>



              </div>

              <div class="form-row">

                <div class="col-md-5">
                  <div class="position-relative form-group">
                    <label for="">Substação Origem</label>
                    <select for="" class="form-control" formControlName="subestacaoIdOrigem">
                      <option value="null">selecione</option>
                      <option *ngFor="let t of this.substacoesOrigem" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="position-relative form-group">
                    <label for="">Substação Destino</label>
                    <select for="" class="form-control" formControlName="subestacaoIdDestino">
                      <option value="null">selecione</option>
                      <option *ngFor="let t of this.substacoesDestino" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>

              </div>


            </section>



            <!-- Elemento MP -->
            <section *ngIf="this.form.get('tipoEquipamentoId').value == 4" class="animated fadeInDown">

              <div class="form-row">
                <div class="col-md-2">
                  <div class="position-relative form-group">
                    <label for="">Quantidade</label>
                    <input class="form-control" formControlName="qtde" type="text" maxlength="6" />
                  </div>
                </div>
              </div>

            </section>

            <!-- Ativo Refrigeração  -->
            <section *ngIf="this.form.get('tipoEquipamentoId').value == 5" class="animated fadeInDown">

              <div class="form-row">

                <div class="col-md-2">
                  <div class="position-relative form-group">
                    <label for="">Criticidade</label>
                   
                    <select class="form-control" formControlName="criticidade">
                        <option value="">selecione</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="position-relative form-group">
                    <label for="">Especificação</label>
                    <input class="form-control" formControlName="especificacao" type="text" maxlength="100">
                  </div>
                </div>
              </div>

              <div class="form-row">

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="">Potência</label>
                    <input class="form-control" formControlName="potenciaAR" type="text" maxlength="10">
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="">Contorno</label>
                    
                    <select  class="form-control" formControlName="contorno" >
                      <option value="0">N/A</option>
                      <option value="1">Primária</option>
                      <option value="2">Secundária</option>
                      <option value="3">Terciária</option>
                    </select>

                  </div>
                </div>
              </div>
            </section>



          </section>


        </form>
        
        <div class="text-center">
          <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
        </div>
      </div>

    </div>

  </div>

</div>


<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-6">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)" title="Exluir equipamento selecionado"
                (click)="showModalSm(modaldelete)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
              
              <button type="button" class="btn btn-light pl-3 pr-3 cp" (click)="openModal()">
                <i class="fa fa-search"></i><span class="pl-3">Pesquisar/Editar cadastrados</span>
              </button>
              
            </div>
          </div>
          <div class="col-md-2">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar)) || 
                (this.form.controls.tipoEquipamentoId.value == '' || this.form.controls.classeEquipamentoId.value == '')"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>





<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="d-flex justify-content-center">
            <span class="question-modal pt-3 pb-3">Deseja excluir o <b>equipamento</b> selecionado?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="delete(this.form.get('id').value, c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

  <app-pesquisa-equipamento 
  [shouldOpenModal]="this.shouldOpenModal"
  (EnviarEquipamento)="showEquipamento($event)"
>

</app-pesquisa-equipamento>  


